import { useState } from 'react';
import moment from 'moment';
import { FiBookOpen, FiCheckCircle, FiPauseCircle, FiGift, FiStar } from 'react-icons/fi';
import useFetchPublisherAggregateBooks from 'api/AdminReports/useFetchPublisherAggregateBooks';
import PublisherBooks from 'admin/PublisherDashboard2/PublisherBooks';
import useAuthStore from 'store/authStore';
import { Role } from 'utils/server-constants/roles';
import { MetricCard, ReportPanel } from 'components/PortalDashboard';
import ReportDateRange from 'components/PortalDashboard/ReportDateRange';

export default function PublisherAggregateBooks({ userId }) {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const result = useFetchPublisherAggregateBooks({ from_date: fromDate ? moment(fromDate).format('YYYY-MM-DD') : '', to_date: toDate ? moment(toDate).format('YYYY-MM-DD') : '' }, userId);
    const books = result.data?.data;
    const hasRoles = useAuthStore((state) => state.hasRoles);
    return <ReportPanel skeleton={{ variant: 'metrics', labels: ['All books', 'Active', 'Inactive', 'Free', 'Premium'] }} title="Your catalogue" description="Track the books you bring to Akello readers." result={result} filters={<ReportDateRange id="publisher-books" {...{ fromDate, toDate, setFromDate, setToDate }} />}>
        <div className="portal-metrics portal-catalogue-metrics">{[['All books', 'total', FiBookOpen], ['Active', 'active', FiCheckCircle], ['Inactive', 'inactive', FiPauseCircle], ['Free', 'free', FiGift], ['Premium', 'premium', FiStar]].map(([label, key, Icon]) => <MetricCard key={key} label={label} value={books?.[key] ?? 0} icon={<Icon />} />)}</div>
        {hasRoles([Role.SuperAdmin, Role.Admin]) && <PublisherBooks userId={userId} />}
    </ReportPanel>;
}
